<script>
  import moment from 'moment'

  export default {
    components: {},
    nome: 'resultado-destinatarios',
    props: {
      total: {
        type: Number,
        default: () => 0,
        required: true
      },
      destinatariosErroCep: {
        type: Array,
        default: () => [],
        required: true
      }
    },
    data () {
      return {
        isLoaded: false
      }
    },
    computed: {
      destinatariosCepInvalido () {
        return this.destinatariosErroCep.length
      },
      porcentagemEfetividade () {
        const valor = ((this.destinatariosCepInvalido / this.total) * 100).toFixed(2)
        return {
          valor,
          class: parseInt(valor) === 0 ? 'text-success' : 'text-danger'
        }
      },
      semResultado () {
        return this.total === 0 && this.destinatariosCepInvalido === 0
      }
    },
    filters: {
      formatarData (date) {
        return moment(date).format('DD/MM/YYYY LTS')
      }
    },
    mounted () {
      this.isLoaded = true
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Destinatários com CEP inválido</h1></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel">
          <div class="panel-body">
            <div class="resultado-estatísticas-geracao m-b-lg" v-if="!semResultado">
              <div>Total de Destinatários: <span>{{total}}</span></div>
              <div>Destinatários com CEP inválido: <span>{{destinatariosCepInvalido}}</span></div>
              <div>Inválidos: <span :class="porcentagemEfetividade.class">{{porcentagemEfetividade.valor}}%</span></div>
            </div>
            <div>
              <div class="text-dark resultado-success m-t-xl" v-if="semResultado">
                <i class="fa fa-warning fa-5x"></i>
                <span>Leilão não foi gerado via preparação de leilão!</span>
              </div>
              <div class="text-success resultado-success m-t-xl" v-else-if="parseInt(porcentagemEfetividade.valor) === 100">
                <i class="fa fa-check-circle fa-5x"></i>
                <span>Todos os lotes foram gerados com sucesso!</span>
              </div>
              <table class="table-lotes-leilao table table-clicked table-striped bg-whit b-a" v-else>
                <thead>
                <tr>
                  <th class="text-nowrap">CEP</th>
                  <th class="text-nowrap">Nome</th>
                  <th class="text-nowrap">Cidade</th>
                  <th class="text-nowrap">Endereço</th>
                </tr>
                </thead>
                <tbody>
                <tr class="leilao-list-lote-item" v-for="item in destinatariosErroCep">
                  <td>{{item.cep}}</td>
                  <td>{{item.nome}}</td>
                  <td>{{item.cidade}}</td>
                  <td>{{item.endereco}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .resultado-estatísticas-geracao {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
  .resultado-estatísticas-geracao span {
    font-weight: bold;
  }
  .resultado-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
</style>



// WEBPACK FOOTER //
// ResultadoDestinatarios.vue?47b56c29